import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=944957c4"
import script from "./MessageForm.vue?vue&type=script&lang=ts"
export * from "./MessageForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports